// filterJsonSchema.js

import {
  CODE_GROUP_CREATION_TYPE,
  CODE_GROUP_LIFE_CYCLE_STATUS,
  PRODUCER_COMPANIES,
} from "../../utils/constants";
export const codeGroupFilterJsonSchema = {
  type: "object",
  properties: {
    category: {
      type: "array",
      items: {
        type: "string",
        options: [
          { id: "DEFAULT", displayText: "Default" },
          { id: "SUPPORT", displayText: "Support" },
        ],
      },
      title: "Type",
    },
    creationType: {
      type: "array",
      items: {
        type: "string",
        options: [
          {
            id: CODE_GROUP_CREATION_TYPE.PRE_GENERATED,
            displayText: "Uploaded",
          },
          {
            id: CODE_GROUP_CREATION_TYPE.SYSTEM_GENERATED,
            displayText: "Generated",
          },
        ],
      },
      title: "Creation Type",
    },
    lifecycleStatus: {
      items: {
        type: "string",
        options: Object.values(CODE_GROUP_LIFE_CYCLE_STATUS).map((status) => ({
          id: status,
          displayText: status,
        })),
      },
    },
    producerCompany: {
      enum: Object.values(PRODUCER_COMPANIES),
    },
    activeStartDateFrom: {
      type: "string",
      format: "date",
      title: "Active Start Date",
    },
    activeEndDateTo: {
      type: "string",
      format: "date",
      title: "Active End Date",
    },
    codeCount: {
      type: "number",
      title: "Code Count",
    },
    usedCode: {
      type: "number",
      title: "Used Count",
    },
  },
};

export const codeGroupFilterUiSchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "HorizontalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/category",
          component: "multiSelect",
          selection: "multiple",
          placeholder: "Type",
        },
        {
          type: "Control",
          scope: "#/properties/creationType",
          component: "multiSelect",
          selection: "multiple",
          placeholder: "Creation Type",
        },
        {
          type: "Control",
          scope: "#/properties/lifecycleStatus",
          component: "multiSelect",
          selection: "multiple",
          placeholder: "Status",
        },
        {
          type: "Control",
          scope: "#/properties/activeStartDateFrom",
          component: "dateTimePicker",
          label: "Active Start Date",
        },
        {
          type: "Control",
          scope: "#/properties/activeEndDateTo",
          component: "dateTimePicker",
          label: "Active End Date",
        },
        {
          type: "Control",
          scope: "#/properties/producerCompany",
          component: "muiSelect",
          placeholder: "Producer Company",
        },
        {
          type: "Control",
          scope: "#/properties/codeCount",
          component: "rangeFilter",
          label: "Code Count",
        },
        {
          type: "Control",
          scope: "#/properties/usedCode",
          component: "rangeFilter",
          label: "Used Count",
        },
      ],
    },
  ],
};

export const debouceCodeGroupFilterJsonSchema = {
  type: "object",
  properties: {
    codeGroupName: {
      type: "string",
      title: "Search by code group name",
    },
    campaignId: {
      type: "string",
      title: "Campaign ID",
    },
    campaignName: {
      type: "string",
      title: "Campaign Name",
    },
  },
};

export const debounceCodeGroupFilterUiSchema = {
  type: "HorizontalLayout",
  elements: [
    {
      type: "Control",
      scope: "#/properties/codeGroupName",
      component: "searchInput",
      placeholder: "Search by code group name",
    },
    {
      type: "Control",
      scope: "#/properties/campaignId",
      component: "searchInput",
      placeholder: "Campaign ID",
    },
    {
      type: "Control",
      scope: "#/properties/campaignName",
      component: "searchInput",
      placeholder: "Campaign Name",
    },
  ],
};
